const STAGING_DASHBOARD_HOSTNAME = "staging-dashboard.youzu.ai";

export const getEnvironmentLabel = (hostname: string): "Staging" | null =>
  hostname === STAGING_DASHBOARD_HOSTNAME ? "Staging" : null;
